// https://discuss.reactjs.org/t/global-jsx-file-for-utility-classes-used-across-app/5502/2

import Constants from "../constants/Constants";
import Content from "../content/Content";

export function generateReactKey () {
    return "rk" + Constants.REACT_KEY++;
}

export function log (message, type) {
    if(Constants.DEV_MODE){
        console.log(message);
    }
}

export function appendHttpUrlToApi(url) {
    if(Constants.DEBUG_MODE) {
        return "http://localhost:9080" + url
    }
    else {
        return url
    }
}

export function decideValueYear (value){

    if(value){
        if (value === 0 || value === 1)
            return value  + " year  ";
        else
            return value + " years  "
    }else
    {
        return "";
    }
}

export function decideValueMonth (value) {
    if (value)
    {
        if (value === 0 || value === 1)
            return value + " month  ";
        else
            return value + " months  ";
    }
    else
    {
        return "";
    }
}

export function getExperienceText(valueInMonths) {
    let experienceText = null;
    if(valueInMonths !== null && valueInMonths !== undefined){
        let totalYears = parseInt(valueInMonths/12), totalMonths = valueInMonths%12;
        if(parseInt(valueInMonths) >= 20*12 ){
            experienceText = "20+ years";
        }else if(parseInt(valueInMonths) > 0){
            experienceText = decideValueYear(totalYears) + decideValueMonth(totalMonths);
        }else if(parseInt(valueInMonths) <=0){
            experienceText = "Fresher";
        }
    }
    return experienceText;
}

//FIXME default icon location should be from google storage
export function validateUrl (url, img_type) {
    if(!url){
        switch(img_type){
            //Constants.img_type.prof_pic
            case 1 :
                return 'https://storage.googleapis.com/ck-staging/ck_app_assets/ck-avatar-male.svg';

            case 2 :
                return '/static/images/icons/mask.png';
        }
    }else{
        return url;
    }
}

export function setItemInLocalStorage (key, item) {
    try{
        console.log("storing in local store");
        window.localStorage.setItem(key, item);
    }catch(e){
        console.log("error while inserting data")
    }
}

export function getItemFromLocalStorage (key) {
    try{
        return window.localStorage.getItem(key);
    }catch(e){
        return null;
    }
}

export function setItemInStorage (key, item) {
    try{
        window.sessionStorage.setItem(key, item);
    }catch(e){
        console.log("error while inserting data")
    }
}

export function getItemFromStorage (key) {
    try{
        return window.sessionStorage.getItem(key);
    }catch(e){
        return null;
    }
}

export function handleAuthenticationFailure () {
    // window.location.href = "/";
    window.location.replace('/?login=true&login_type=1');
}

export function bindThisToAll(_this, ...methods) {
    methods.map(method=>_this[method]=_this[method].bind(_this));
}


export function onWindowResize  (fn) {
    let window_height_curr = window.innerHeight;
    window.onresize = function () {
        let window_height_new = window.innerHeight;
        fn(window_height_curr, window_height_new);
    };
}

export function ignoreWindowResize (){
    window.onresize = function () {
    };
}

function getStoreObject (){
    if(!window.ckStore  || typeof window.ckStore !== "object"){
        window.ckStore = {
        };
    }
    return window.ckStore

}
//should be set at very end of ongoing process and must be displayed immediately to avoid possible conflicts with other global notifications
export function storeMsg (key = "key", msg) {
    let store = getStoreObject();
    store[key] = msg;
}

export function getMsg (key = "key") {
    let storeObject = getStoreObject();
    const msg = storeObject[key];
    storeObject[key] = null;
    return msg;
}

export function setNotifMsg (msg) {
    let store = getStoreObject();
    store.notifMsg = msg;
}

export function getNotifMsg () {
    let storeObject = getStoreObject();
    const msg = storeObject.notifMsg;
    storeObject.notifMsg = '';
    return msg;
}

export function getDate () {
    let strDate = document.getElementById("ck-date").value,
        aryDate = strDate.split("-")
    ;

    return {
        day: parseInt(aryDate[0]),
        month: parseInt(aryDate[1]),
        year: parseInt(aryDate[2])
    };

}

export function getYearMonth(months) {
    return {
        years: Math.floor(months/12),
        months: months%12
    }
}

export function getMonthsList () {
    return [
        {id: 1, value: "Jan"},
        {id: 2, value: "Feb"},
        {id: 3, value: "March"},
        {id: 4, value: "April"},
        {id: 5, value: "May"},
        {id: 6, value: "June"},
        {id: 7, value: "July"},
        {id: 8, value: "Aug"},
        {id: 9, value: "Sep"},
        {id: 10, value: "Oct"},
        {id: 11, value: "Nov"},
        {id: 12, value: "Dec"}
    ];
}

const FILE_ICON_LIST = Constants.FILE_ICON_LIST;
export function getFileIcon(fileName) {
    let extn = fileName.substring(fileName.lastIndexOf('.')+1, fileName.length) || fileName
    ;

    if(!extn){
        extn = "default";
    }
    extn = "default";
    return FILE_ICON_LIST[extn];
}

export function isFileSupported(filename, extension_list) {
    // return true;
    let extn = filename.substring(filename.lastIndexOf('.')+1, filename.length) || filename, extn_list;

    if(!extn)
        return false;

    extn_list = (extension_list)?extension_list:Constants.SUPPORTED_FILE_TYPE_LIST;

    return (extn_list.indexOf(extn.toLowerCase()) >= 0);

}

export function deepCopy(o){
    let output, v, key;
    output = Array.isArray(o) ? [] : {};
    for (key in o) {
        v = o[key];
        output[key] = (v && typeof v === "object") ? deepCopy(v) : v;
    }
    return output;
}

export function toLacs(thousands) {
    log("to Lacs : "+thousands);
    return (thousands / 100000).toFixed(2);
}

export function mapNoticePeriod (noticePeriod) {
    console.log(noticePeriod);
    if(!noticePeriod){
        return Content.NOT_APPLICABLE;
    }
    if(noticePeriod >= 60){
        return Constants.NOTICE_PERIOD_MAP["4"]
    } else if(noticePeriod >= 45){
        return Constants.NOTICE_PERIOD_MAP["3"]
    }else if( noticePeriod >= 30){
        return Constants.NOTICE_PERIOD_MAP["2"]
    }else{
        return Constants.NOTICE_PERIOD_MAP["1"]
    }
}

export function hidePageLoader() {
    let el = document.getElementById("page-loader");
    el.parentNode.removeChild(el);
}



// WEBPACK FOOTER //
// ./src/utility/Utility.js